import Grainient from "design-system/atoms/Grainient/GrainientEffect"
import { useTheme } from "design-system/theme"

export const AuthBackground = () => {
  const { theme } = useTheme()
  const colors =
    theme === "light" ? ["#2a4d21", "#91bfdd", "#d1ba36"] : ["#3b5d68", "#1c373f", "#afa3db"]

  return (
    <div className="absolute inset-0">
      <Grainient
        color1={colors.at(0)}
        color2={colors.at(1)}
        color3={colors.at(2)}
        timeSpeed={1}
        colorBalance={0.05}
        warpStrength={0.8}
        warpFrequency={5}
        warpSpeed={2}
        warpAmplitude={80}
        blendAngle={-8}
        blendSoftness={0.25}
        rotationAmount={540}
        noiseScale={0.45}
        grainAmount={0.07}
        grainScale={3.9}
        grainAnimated={false}
        contrast={1.2}
        gamma={1.5}
        saturation={1.2}
        centerX={0.01}
        centerY={0.09}
        zoom={1}
      />
    </div>
  )
}
